import { render, staticRenderFns } from "./1010.vue?vue&type=template&id=731b89ab&scoped=true&"
import script from "./1010.vue?vue&type=script&lang=js&"
export * from "./1010.vue?vue&type=script&lang=js&"
import style0 from "./1010.vue?vue&type=style&index=0&id=731b89ab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731b89ab",
  null
  
)

export default component.exports